import Box from "ds/components/Box";
import Toggle from "ds/components/Toggle";
import Typography from "ds/components/Typography";
import { ColumnId } from "components/DragDropList/types";

import { Widget } from "../types";

const DashboardManageDrawerTabItemTitle = ({
  title,
  checked,
  onSelect,
  columnId,
  id,
}: {
  title: string;
  checked: boolean;
  onSelect?: (columnId: ColumnId, id: Widget, isSelected: boolean) => void;
  columnId?: ColumnId;
  id: Widget;
}) => {
  return (
    <Box justify="between" align="center" grow="1">
      <Box align="center" gap="large">
        <Typography tag="span" variant="p-t7">
          {title}
        </Typography>
      </Box>
      <Box gap="small" align="center">
        {onSelect && (
          <Toggle
            variant="checkbox"
            tooltip={(isSelected) => (isSelected ? "Deactivate" : "Activate")}
            isSelected={checked}
            onChange={columnId ? (isSelected) => onSelect(columnId, id, isSelected) : undefined}
          />
        )}
      </Box>
    </Box>
  );
};

export default DashboardManageDrawerTabItemTitle;
